module.exports = __webpack_public_path__ + "img/reference02.961220ca.jpg";